import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment/moment';
import { CreateChancel, DateTypeSelect, SelectTypeAutocomplete, SelectAutocompletePagination } from 'components';
import { renderClientName, useModal } from 'utils';
import { CsvService } from 'store';

export const DownloadBillingInvoice = ({}) => {
    const [error, setError] = useState('');
    const [inputs, setInputs] = useState({});
    const [load, setLoad] = useState(false);
    const { close } = useModal();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;

    useEffect(() => {
        if (info) {
            const params = {
                from: info?.from,
                to: info?.to,
                client: info?.client,
                status: info?.status,
            };
            setInputs(params);
        }
    }, [info]);
    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        error === e.target.name && setError('');
    };

    const handleExport = async () => {
        setLoad(true);
        let response = '';

        const params = {
            from: inputs?.from,
            to: inputs?.to,
            status: inputs?.status,
        };

        inputs?.client ? (params.client = inputs.client) : delete params.client;

        try {
            response = await CsvService.getInvoicePaymentCsv(params);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `invoice.csv`);
            document.body.appendChild(link);
            link.click();
            setLoad(false);
            close();
        } catch (e) {
            setLoad(false);
            close();
        }
    };

    return (
        <div className="download-payroll-csv-modal">
            <p className="download-modal-title">Download Invoice Data</p>
            <p className="download-modal-desc">
                Select filters for the invoice data you wish to download. The fields will be pre-filled based on your current filters.
            </p>
            <div className="download-modal-body">
                <SelectAutocompletePagination
                    title={'Client'}
                    name={'client'}
                    handleSelect={handleChange}
                    defaultValue={info?.client}
                    renderValue={(i) => renderClientName(i)}
                    type={'client'}
                    currentSelected={info?.clientFull && info?.clientFull}
                />
                <SelectTypeAutocomplete
                    title={'Status'}
                    name={'status'}
                    handleSelect={handleChange}
                    defaultValue={inputs?.status}
                    list={[
                        { name: 'Open', id: 'OPEN' },
                        { name: 'Paid', id: 'PAID' },
                        { name: 'Closed', id: 'CLOSED' },
                    ]}
                    renderValue={(i) => i?.name}
                    placeholder={'Select Client'}
                />
                <div className="start-end-time-box">
                    <DateTypeSelect
                        type={'modalInput'}
                        name={'from'}
                        outLabel={'Start Date'}
                        handleGetDates={handleChange}
                        values={inputs}
                        max={inputs.to ? moment.utc(inputs.to).format('YYYY-MM-DD') : ''}
                    />
                    <DateTypeSelect
                        type={'modalInput'}
                        name={'to'}
                        outLabel={'End Date'}
                        handleGetDates={handleChange}
                        values={inputs}
                        min={inputs.from ? moment.utc(inputs.from).format('YYYY-MM-DD') : ''}
                    />
                </div>
            </div>

            <div>
                <CreateChancel
                    loader={load}
                    create={'Download CSV'}
                    chancel={'Cancel'}
                    onCreate={handleExport}
                    onClose={() => close()}
                    buttonWidth="300px"
                />
            </div>
        </div>
    );
};
